module.exports = __webpack_public_path__ + "static/media/concierge-bell.a94729b2.svg";